export default class StringTool {
  static readonly LEFT_TRIM_TAB_EXPR = /^\t*/g;

  static readonly RIGHT_TRIM_TAB_EXPR = /\t*$/g;

  static readonly BLANK : string = '';

  public static trimTabs(text: string | null): string | null {
    if (!text) {
      return text;
    }

    const leftTrim = text.replace(this.LEFT_TRIM_TAB_EXPR, this.BLANK);
    return leftTrim.replace(this.RIGHT_TRIM_TAB_EXPR, this.BLANK);
  }
}
